import React from "react";
import { useTranslation } from "react-i18next";

export default function LanguageSelector() {
    const { i18n } = useTranslation();


    const handleChangeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };

    return (
        <div className="dropdown language-selector">
            <button
                className="btn dropdown-toggle"
                data-bs-display="static"
                type="button"
                id="languageDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
            >
                {i18n.language === "sr" ? "Srpski" : "English"}
            </button>
            <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="languageDropdown"
            >
                <li>
                    <button
                        className="dropdown-item"
                        onClick={() => handleChangeLanguage("rs")}
                    >
                        🇷🇸 Srpski
                    </button>
                </li>
                <li>
                    <button
                        className="dropdown-item"
                        onClick={() => handleChangeLanguage("en")}
                    >
                        🇬🇧 English
                    </button>
                </li>
            </ul>
        </div>
    );
}
